import { useMainContext } from '@/context/main-context';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

NProgress.configure({ showSpinner: false, trickleSpeed: 200, minimum: 0.05 });

function TopLoader({ loading }) {
  useEffect(() => {
    if (loading) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [loading]);

  return null;
}

export default function ProtectedRoute({ children }) {
  const { user, loading, collectionsLoading } = useMainContext();

  if (loading) {
    return <TopLoader loading={true} />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <TopLoader loading={collectionsLoading} />
      {children}
    </>
  );
}
